(function () {
  const STYLE_ID = 'cart-recommendation-variant-styles';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .cart-recommendation-card .horizontal-product__details {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        overflow: hidden !important;
      }

      .cart-recommendation-card .horizontal-product__title {
        display: -webkit-box !important;
        overflow: hidden !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
      }

      .cart-recommendation-card cart-recommendation-variant,
      .cart-recommendation-card form {
        display: block !important;
        width: 100% !important;
        min-width: 0 !important;
      }

      .cart-recommendation-card__actions {
        box-sizing: border-box !important;
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) auto !important;
        align-items: center !important;
        gap: 8px !important;
        width: 100% !important;
        min-width: 0 !important;
      }

      .cart-recommendation-card__actions .field {
        width: 100% !important;
        min-width: 0 !important;
      }

      .cart-recommendation-card__actions .select {
        box-sizing: border-box !important;
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        padding-inline-end: 32px !important;
        font-size: 12px !important;
      }

      .cart-recommendation-card__actions button[type='submit'] {
        box-sizing: border-box !important;
        min-width: 48px !important;
        max-width: 58px !important;
        padding-inline: 9px !important;
        margin: 0 !important;
        white-space: nowrap !important;
      }
    `;

    document.head.appendChild(style);
  }

  installStyles();

  if (customElements.get('cart-recommendation-variant')) return;

  class CartRecommendationVariant extends HTMLElement {
    connectedCallback() {
      installStyles();

      if (this.dataset.initialized === 'true') return;

      this.card = this.closest('.horizontal-product');
      this.actions = this.querySelector('form > div');
      this.card?.classList.add('cart-recommendation-card');
      this.actions?.classList.add('cart-recommendation-card__actions');

      this.select = this.querySelector('select[name="id"]');
      this.button = this.querySelector('button[type="submit"]');
      this.price = this.card?.querySelector('[data-variant-price]');
      this.image = this.card?.querySelector('.horizontal-product__media img');

      if (!this.select) return;

      this.dataset.initialized = 'true';
      this.select.addEventListener('change', this.updateVariant.bind(this));
      this.updateVariant();
    }

    updateVariant() {
      const option = this.select.options[this.select.selectedIndex];
      if (!option) return;

      if (this.price && option.dataset.price) {
        this.price.textContent = option.dataset.price;
      }

      if (this.image && option.dataset.imageSrc) {
        this.image.src = option.dataset.imageSrc;

        if (option.dataset.imageSrcset) {
          this.image.srcset = option.dataset.imageSrcset;
        }

        if (option.dataset.imageAlt) {
          this.image.alt = option.dataset.imageAlt;
        }
      }

      if (this.button) {
        this.button.dataset.variantId = option.value;
      }
    }
  }

  customElements.define('cart-recommendation-variant', CartRecommendationVariant);
})();
